import { isDevelopment } from "@/lib/constants/env";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { z } from "zod";
import { zodI18nMap } from "zod-i18n-map";
import deZod from "zod-i18n-map/locales/de/zod.json";
import enZod from "zod-i18n-map/locales/en/zod.json";

import de from "./de.json";
import en from "./en.json";

// Type check: ensure both files have exactly the same keys
// (Keeping this file touched ensures TS re-evaluates JSON key unions for typed `t()` usage.)
en satisfies typeof de;
de satisfies typeof en;

// Augment i18next types
declare module "i18next" {
  interface CustomTypeOptions {
    defaultNS: "translation";
    resources: {
      translation: typeof de;
    };
    returnNull: true;
  }
}

const supportedLngs = ["de"];
const resources: Record<string, { zod: typeof deZod; translation: typeof de }> =
  {
    de: {
      zod: deZod,
      translation: de,
    },
  };
if (isDevelopment) {
  supportedLngs.push("en", "en-US");
  resources.en = {
    zod: enZod,
    translation: en,
  };
  resources["en-US"] = {
    zod: enZod,
    translation: en,
  };
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)

  .init({
    supportedLngs,
    fallbackLng: "de",
    detection: {
      order: ["path", "cookie", "navigator", "htmlTag"],
      caches: ["cookie"],
    },
    defaultNS: "translation",
    resources,
  });

z.setErrorMap(zodI18nMap);

export default i18n;
